import { useGetHttp } from "../../../http.hook";
import { IGetPayoutPendingListResponse } from "./get-pending-payout.admin.http";

export function useSearchPayoutAdminHttp() {
  return useGetHttp<IGetPayoutPendingListResponse>({
    path: "/admin/kyc/creator/payout/search",
  });
}